import PropTypes from 'prop-types';
import React from 'react';

import CustomTooltip from '../CustomTooltip';

const BooleanTooltip = ({ children, condition, ...props }) =>
  condition ? <CustomTooltip {...props}>{children}</CustomTooltip> : <>{children}</>;

BooleanTooltip.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.string]).isRequired,
  condition: PropTypes.bool.isRequired,
};

export default BooleanTooltip;
